import { useRef, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import omit from 'lodash/omit';

const TextareaInput = ({
	inputType: inputTypeProp,
	onChangePlainValue,
	onChange,
	className,
	label,
	validationError,
	autoComplete,
	value,
	innerContent,
	hideError,
	placeholder,
	...props
}) => {
	const inputRef = useRef();

	// Set initial plain value.
	const plainValue = useMemo(() => {
		return value;
	}, [value, inputTypeProp]);

	const isFull = useMemo(() => !!value?.length, [value]);

	const inputProps = useMemo(() => omit(props, ['initialized']), [props]);

	useEffect(() => {
		onChangePlainValue(plainValue);
	}, [plainValue]);

	const handleChange = (e) => {
		onChange(e.target.value);
	};

	useEffect(() => {
		if (
			inputRef.current &&
			typeof inputRef.current === 'function' &&
			inputRef.current.matches(':-internal-autofill-selected')
		) {
			inputRef.current.click();
		}
	}, []);

	return (
		<div
			className={classNames(className, 'type-textarea', {
				'input-full': isFull,
				'has-counter': !!props.maxLength,
			})}
		>
			<div className={'inputwrap-outerwrap' + (label ? '' : ' no-label')}>
				{label && (
					<label className="input-label" htmlFor={props.id}>
						<div className="label-text">
							{label}
							{/*((vm.state.validation !== false && vm.state.validation.required) && vm.props.showValidationAsterisk) && <span className="label-asterisk">*</span>*/}
						</div>
					</label>
				)}
				<div className="inputwrap-innerwrap">
					{innerContent}
					<textarea
						ref={inputRef}
						onChange={handleChange}
						className={'inputwrap-input'}
						autoComplete={autoComplete || 'off'}
						placeholder={placeholder ?? label}
						value={value}
						{...inputProps}
					/>
				</div>
			</div>
			{!!(validationError && !hideError) && <div className="input-error">{validationError}</div>}
			{props.maxLength && (
				<span className="input-counter">
					{props.maxLength - value.length} / {props.maxLength}
				</span>
			)}
		</div>
	);
};

export default TextareaInput;
